// The dataKeys that are used in code that need to always exists in the db
export enum HARDCODED_DATA_KEY {
  COMPLAINT_LOG = "complaint-log",
  LIST_OF_QUALIFIED_SUPPLIERS = "list-of-qualified-suppliers",
  PUBMED_SEARCH_STRING = "pubmed-search-string",
  COCHRANE_SEARCH_STRING = "cochrane-search-string",
  CLINICAL_TRIAL_SEARCH_TABLE_RAW_CSV = "clinical-trial-search-table-raw-csv",
  CLINICAL_TRIAL_SEARCH_TABLE = "clinical-trial-search-table",
  CLINICAL_TRIALS_INDIVIDUAL_SUMMARY = "clinical-trials-individual-summary",
  RISK_ANALYSIS_RESULTS = "risk-analysis-results",
  SOUP_DEPENDENCIES = "soup-dependencies",
  SOUP_LIST = "soup-list",
  SYSTEM_TEST_REPORT = "system-test-report",
  BUG_TEST_RESULTS = "bug-test-results",
  VALIDATION_HISTORY = "validation-history",
  RISK_HAZARDS = "risk-hazards",
  LITERATURE_SEARCH_RESULTS = "literature-search-results",
  PERFORMANCE_LITERATURE_DEVICE = "performance-literature-device",
  PERFORMANCE_LITERATURE_STATE_OF_THE_ART = "performance-literature-state-of-the-art",
  SAFETY_LITERATURE_DEVICE = "safety-literature-device",
  SAFETY_LITERATURE_STATE_OF_THE_ART = "safety-literature-state-of-the-art",
  CLINICAL_TRIALS_SEARCH_RESULTS = "clinical-trials-search-results",
  FSN_DESCRIPTION = "fsn-description",
  RELEASE_DOCUMENTS = "release-documents",
  MANAGEMENT_REVIEW_SIGNATURES = "management-review-signatures",
  CHANGE_SOFTWARE_ITEMS = "change-software-items",
}
